import * as React from "react";
import styles from "./styles.module.css";

const HeaderContent: React.FC<{
	title: string;
	description?: string;
}> = ({ title, description }) => {
	return (
		<div className="d-flex flex-column">
			<div className={`${styles.hero}`}>
				<h1 className={styles.hero__title}>{title}</h1>
				<p>{description}</p>
			</div>
		</div>
	);
};

export default HeaderContent;
